
<div class="searchContainer">
  <ng-select
    id="searchType"
    class="col-xl-4 col-lg-4 col-md-4 searchTypeSelector"
    [searchable]="false"
    [clearable]="false"
    [(ngModel)]="selectedSearchType"
    >
    @for (searchType of searchTypes; track searchType) {
      <ng-option [value]="searchType">
        {{'searchTypes.' + searchType | cxTranslate}}
      </ng-option>
    }
  </ng-select>

  <div class="searchBoxAndResults">
    <label class="searchbox" [class.dirty]="!!searchInput.value">
      <input
        #searchInput
        [placeholder]="'searchBox.placeholder' | cxTranslate"
        aria-label="search"
        (focus)="open()"
        (click)="open()"
        (input)="search(searchInput.value)"
        (blur)="close()"
        (keydown.escape)="close()"
        (keydown.enter)="
          close( true);
          launchSearchResult( searchInput.value);
          updateChosenWord(searchInput.value)
        "
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        value="{{ chosenWord }}"
        />

        <cx-icon
          [type]="iconTypes.RESET"
          aria-label="reset"
          (mousedown)="clear(searchInput)"
          (keydown.enter)="clear(searchInput)"
          class="reset"
          tabindex="0"
        ></cx-icon>

        <cx-icon
          [type]="iconTypes.SEARCH"
          aria-label="search"
          class="search"
          (mousedown)="avoidReopen($event)"
          (keydown.enter)="avoidReopen($event)"
          tabindex="0"
        ></cx-icon>
      </label>


      @if (results$ | async; as result) {
        <div
          class="results"
          (click)="close( true)"
          >
          <div class="message suggestions-title">
            {{'search.title' | cxTranslate}}
          </div>
          @if (result.message) {
            <div
              class="message"
              [innerHTML]="result.message"
            ></div>
          }
          <div class="suggestions">
            @for (suggestion of result.suggestions; track suggestion) {
              <a
                [innerHTML]="suggestion | highlight: searchInput.value"
      [routerLink]="
        {
          cxRoute: 'search',
          params: { query: suggestion }
        } | cxUrl
      "
                (keydown.arrowup)="focusPreviousChild($event)"
                (keydown.arrowdown)="focusNextChild($event)"
                (keydown.enter)="close( true)"
                (keydown.escape)="close( true)"
                (blur)="close()"
                (mousedown)="preventDefault($event)"
      (click)="
        dispatchSuggestionEvent({
          freeText: searchInput.value,
          selectedSuggestion: suggestion,
          searchSuggestions: result.suggestions
        });
        updateChosenWord(suggestion)
      "
                >
              </a>
            }
          </div>
          @if (result.products) {
            <div class="products">
              @for (product of result.products; track product) {
                <a
        [routerLink]="
          {
            cxRoute: 'product',
            params: product
          } | cxUrl
        "
                  [class.has-media]="config.displayProductImages"
                  (keydown.arrowup)="focusPreviousChild($event)"
                  (keydown.arrowdown)="focusNextChild($event)"
                  (keydown.enter)="close( true)"
                  (keydown.escape)="close( true)"
                  (blur)="close($event)"
                  (mousedown)="preventDefault($event)"
        (click)="
          dispatchProductEvent({
            freeText: searchInput.value,
            productCode: product.code
          })
        "
                  >
                  @if (config.displayProductImages) {
                    <cx-media
                      [container]="product.images?.PRIMARY"
                      format="thumbnail"
                      [alt]="product.summary"
                    ></cx-media>
                  }
                  <h4 class="name" [innerHTML]="product.nameHtml"></h4>
                  <span class="price">{{ product.price?.formattedValue }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    </div>

  </div>
